/**
 * Edge rules for class diagrams.
 * Maps relationship types to draw.io edge style extras.
 */

import type { IRGraph } from '../types';

const REL_STYLES: Record<string, string> = {
  inheritance: 'endArrow=block;endFill=0;',
  composition: 'endArrow=diamond;endFill=1;',
  aggregation: 'endArrow=diamond;endFill=0;',
  dependency: 'dashed=1;endArrow=open;endFill=0;',
  association: 'endArrow=open;endFill=0;',
};

export function applyEdgeRules(graph: IRGraph): void {
  for (const edge of graph.edges) {
    const relType = (edge.meta?.relationType as string) ?? 'association';
    const relStyle = REL_STYLES[relType] ?? REL_STYLES.association;
    if (!edge.meta) edge.meta = {};
    edge.meta.edgeStyleExtras = relStyle;
  }
}
